import { USER_ROUTE } from '@/shared/constants'
import { removeStar } from '@/shared/utils'

/**
 * Processing navigation route to this user page
 * use to provide <NavLink> `[to]` parameters
 *
 * @param path
 */
export function userNavLink(path: string) {
  const newPath = removeStar(path)
  const withSlash = newPath ? `/${newPath}` : ''
  return `${USER_ROUTE}${withSlash}`
}

/**
 * pre process setting nav link
 */
export function settingNavLink(path: string) {
  const withSlash = path ? `/${path}` : ''
  return `${USER_ROUTE}${withSlash}`
}
